export default "__VITE_ASSET__p_F4_WxK__"